/*
 * SUPABASE CONNECTION
 */

import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Validation to ensure env vars are loaded
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables. Please check your .env file.'
  );
}

// Create Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: false  // Logout on browser close/reopen
  }
});

// ══════════════════════════════════════════════════════════════════════════════
// AUTHENTICATION HELPERS
// ══════════════════════════════════════════════════════════════════════════════

/**
 * Get current authenticated user ID
 * @returns {Promise<string>} User ID
 * @throws {Error} If not authenticated
 */
export async function getCurrentUserId() {
  const { data: { user }, error } = await supabase.auth.getUser();
  
  if (error) throw error;
  if (!user) throw new Error('Not authenticated');
  
  return user.id;
}

/**
 * Check if user is authenticated
 * @returns {Promise<boolean>} True if authenticated, false otherwise
 */
export async function isAuthenticated() {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    return !!user;
  } catch (error) {
    return false;
  }
}